import { format, isValid } from 'date-fns';

export const formatDate = (value: string | Date | null | undefined): string => {
  if (!value) return '-';
  const date = new Date(value);
  return isValid(date) ? format(date, 'MMM dd, yyyy') : '-';
};

export const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return format(date, 'dd MMM yyyy HH:mm');
  } catch {
    return '-';
  }
};

export const formatDateTimeWithMs = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return format(date, 'dd MMM yyyy HH:mm:ss.SSS');
  } catch {
    return '-';
  }
};
